module.exports = __webpack_public_path__ + "static/media/strategy.3a783a1e.mp4";